export const HANDLER_STROKE_WIDTH = 2
export const HANDLER_RADIUS = 6
export const SNAP_THRESHOLD = 50
